/**
 * Generato automaticamente.
 * framework-cmp-procedimenti
 */

export type CollegamentoIstanzaDettaglioDTOTipo =
  (typeof CollegamentoIstanzaDettaglioDTOTipo)[keyof typeof CollegamentoIstanzaDettaglioDTOTipo];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollegamentoIstanzaDettaglioDTOTipo = {
  OSSERVAZIONE: 'OSSERVAZIONE',
} as const;
